module.exports = __webpack_public_path__ + "media/images/character-img-wondering-62e3ed4b1703c81aab50cf1b655a7b2f.png";